import React from 'react';

const svg = {
  width: 12,
  height: 12,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

export default function WaitKindIcon({ kind }) {
  if (kind === 'message') {
    return (
      <svg {...svg}>
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    );
  }
  if (kind === 'call') {
    return (
      <svg {...svg}>
        <path d="M6.5 3.5h3l1.5 3.5-2 1.2a12 12 0 0 0 6.8 6.8l1.2-2 3.5 1.5v3a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 4.5 5.7 2 2 0 0 1 6.5 3.5z" />
      </svg>
    );
  }
  if (kind === 'meeting') {
    return (
      <svg {...svg}>
        <rect x="3" y="5" width="18" height="16" rx="2" />
        <path d="M3 10h18M8 3v4M16 3v4" />
      </svg>
    );
  }
  if (kind === 'approval') {
    return (
      <svg {...svg}>
        <circle cx="12" cy="12" r="8" />
        <path d="M8.5 12.5 11 15l4.5-5.5" />
      </svg>
    );
  }
  if (kind === 'delivery') {
    return (
      <svg {...svg}>
        <path d="M21 8 12 3 3 8v8l9 5 9-5V8z" />
        <path d="M3.5 8.5 12 13l8.5-4.5M12 13v8" />
      </svg>
    );
  }
  if (kind === 'payment') {
    return (
      <svg {...svg}>
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <path d="M2 10h20" />
      </svg>
    );
  }
  if (kind === 'other') {
    return (
      <svg {...svg}>
        <circle cx="6" cy="12" r="1.25" fill="currentColor" stroke="none" />
        <circle cx="12" cy="12" r="1.25" fill="currentColor" stroke="none" />
        <circle cx="18" cy="12" r="1.25" fill="currentColor" stroke="none" />
      </svg>
    );
  }
  return (
    <svg {...svg}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </svg>
  );
}
